import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export const BackButton = ({ variants }) => {
  const navigate = useNavigate();

  return (
    <motion.div variants={variants} className="mb-8">
      <Button variant="outline" onClick={() => navigate("/list-inventory")}>
        <ArrowLeft className="mr-2 h-4 w-4" /> Back to Memberships
      </Button>
    </motion.div>
  );
};
